import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Filters } from '../filters';
import { SearchStore } from '../../../stores/SearchStore';
import styles from './FiltersMobile.css';
import iconClose from './icon-close.svg';

const IPropTypes = {
  className: PropTypes.string,
  callbackCloseFilters: PropTypes.func.isRequired,
};

const defaultProps = {
  className: '',
};

class FiltersMobile extends React.Component {
  static onClearFilters(event) {
    event.preventDefault();
    SearchStore.clearFilters();
  }

  constructor(props) {
    super(props);
    this._onCloseElementClick = this._onCloseElementClick.bind(this);
  }

  _onCloseElementClick(event) {
    event.preventDefault();
    this.props.callbackCloseFilters(event);
  }

  render() {
    if (!SearchStore.filtersValid) {
      return <div className={this.props.className} />;
    }
    return (
      <div className={styles.container}>
        <button
          className={styles.dismiss}
          onClick={this._onCloseElementClick}
        />
        <div className={styles.filtersContainer}>
          <div className={styles.actionContainer}>
            <button
              onClick={this._onCloseElementClick}
              className={styles.iconClose}
            >
              <img src={iconClose} alt="close" />
            </button>
            <div className={styles.verticalStack}>
              <span className={styles.title}>Filtros</span>
              { SearchStore.selectedFiltersCount > 0 &&
              <span className={styles.countText}>
                { SearchStore.selectedFiltersCount } seleccionados.
              </span>
              }
              <button
                onClick={FiltersMobile.onClearFilters}
                className={styles.cleanFilters}
              >
                Limpiar Filtros
              </button>
            </div>
          </div>
          <Filters className={styles.filters} />
        </div>
      </div>
    );
  }
}

FiltersMobile.propTypes = IPropTypes;
FiltersMobile.defaultProps = defaultProps;

const ObservedFilters = observer(FiltersMobile);

export { ObservedFilters as FiltersMobile };



// WEBPACK FOOTER //
// ./src/pages/search/filters-mobile/FiltersMobile.jsx